// Попап для вывода информационных сообщений

import basePopup from "./base-popup";

const template = /* html */`
    <transition name="fade">
        <base-popup
            id="success-message-popup"
            show-logo
            small-popup
            v-cloak
            v-show="isActive"
        >
            <div class="js-popup-content center-xs popup__content">
                <span v-html="visibleMessage"></span>
                <template v-if="details">
                    <p v-for="detail in details" :key="detail" v-html="detail"></p>
                </template>
            </div>
        </base-popup>
    </transition>
`;

export default {
    template,
    props: {
        message: {
            type: [Array, String],
            required: true,
        },
        details: { type: Array },
        onClose: { type: Function },
        isActive: { type: Boolean },
    },
    watch: {
        isActive(newVal) {
            if (!newVal || !this.onClose) return;
            this.onClose();
        },
    },
    computed: {
        visibleMessage() {
            return Array.isArray(this.message) ? this.message.join(" ") : this.message;
        },
    },
    components: { basePopup },
};
